import { TextArea } from '@components/Form';
import formatDate from '@functions/date-functions';
import { NoteProps } from '@hooks/customer/useRecipeNotes';
import { useFormikContext } from 'formik';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import React from 'react';

interface CommentTextAreaProps {
  note: NoteProps | null;
  visible: boolean;
}
const CommentTextArea = ({ note, visible }: CommentTextAreaProps) => {
  const { setFieldValue } = useFormikContext();
  const { t } = useTranslation();
  const ref = React.useRef<HTMLTextAreaElement>();

  React.useEffect(() => {
    setFieldValue('comment', note?.comment ?? '');
    if (visible) {
      ref.current?.focus();
    }
  }, [note?.comment, visible, setFieldValue]);

  return (
    <TextArea
      ref={ref}
      placeholder={t('recipeNotesContent.placeholder', undefined, {
        default: 'Enter your note here',
      })}
      id="comment"
      name="comment"
      label={
        note?.comment
          ? t(
              'recipeNotesContent.editTitle',
              { title: formatDate(note.createdAt) },
              {
                default: 'Edit {{title}}',
              },
            )
          : t('recipeNotesContent.addTitle', undefined, {
              default: 'Add A Note',
            })
      }
      className="tw-pb-5"
    />
  );
};

export default CommentTextArea;
